  
  jQuery(function ($) {
  
    // Slick sliders init
    const $mainSlider = $('.mobile-main-slider');
    const $thumbSlider = $('.mobile-thumb-slider');
  
    if ($mainSlider.length && $thumbSlider.length) {
      const thumbCount = $thumbSlider.find('.thumb').length;
  
      $mainSlider.slick({
        arrows: false,
        slidesToShow: 1,
        asNavFor: '.mobile-thumb-slider',
        fade: true,
        draggable: true,
        infinite: true
      });
  
      $thumbSlider.slick({
        slidesToShow: Math.min(thumbCount, 4),
        asNavFor: '.mobile-main-slider',
        focusOnSelect: true,
        arrows: false,
        variableWidth: true,
        infinite: true,
        centerMode: false
      });
    }

    // --- Mobile "tap to interact" for iframe 360 product ---
    const $mobileIframeWrappers = $('.block-product-gallery .mobile-layout .iframe-wrapper');

    if ($mobileIframeWrappers.length) {
      // Add a small hint badge
      $mobileIframeWrappers.each(function () {
        const $w = $(this);
        if (!$w.find('.iframe-hint').length) {
          $w.append('<div class="iframe-hint">Tap to interact</div>');
        }
      });

      function deactivate($wrap) {
        $wrap.removeClass('is-interactive');
        const t = $wrap.data('iframeTimer');
        if (t) { clearTimeout(t); $wrap.removeData('iframeTimer'); }
      }

      function activate($wrap) {
        $wrap.addClass('is-interactive');
        const t = $wrap.data('iframeTimer');
        if (t) clearTimeout(t);
        $wrap.data('iframeTimer', setTimeout(function () {
          deactivate($wrap);
        }, 8000));
      }

      // First tap enables interaction; no preventDefault so a swipe can still scroll if needed
      $mobileIframeWrappers.on('touchstart', function () {
        const $wrap = $(this);
        if (!$wrap.hasClass('is-interactive')) {
          activate($wrap);
        }
      });

      // Any page scroll turns interaction back off (keeps scrolling natural)
      let scroll = null;
      $(window).on('scroll', function () {
        if (scroll) cancelAnimationFrame(scroll);
        scroll = requestAnimationFrame(function () {
          $mobileIframeWrappers.filter('.is-interactive').each(function () {
            deactivate($(this));
          });
        });
      });

      // If your mobile slider changes slides, disable interaction so next slide scrolls normally
      if ($mainSlider && $mainSlider.length) {
        $mainSlider.on('beforeChange', function () {
          $mobileIframeWrappers.filter('.is-interactive').each(function () {
            deactivate($(this));
          });
        });
      }
    }
  });
  